<template>
  <ion-content id="app" class="ion-padding">
    <ion-grid>
      <ion-row>
        <ion-col size="12" size-sm="6" offset-sm="3">
          <h1 class="ion-padding">Neue Box oder Tab erstellen</h1>
          <BoxFields modus="new"/>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-content>
</template>

<script>
  import BoxFields from "../../components/box/BoxFields.vue";
  import {mapActions, mapGetters} from "vuex";


  export default {
    name: "BoxNew",
    components: {BoxFields},
    data(){
      return {
      }
    },
    methods: {
      ...mapActions([ "getBoxes" ]),
    },
    computed: mapGetters(["allBoxes"]),
    created() {
      this.getBoxes();
    }
  };
</script>

<style>
  h1 {
    color: #B6B6B6;
  }
</style>
